export default __webpack_public_path__ + "static/media/pie-chart.68764b29.png";